import { RouteRecordRaw } from 'vue-router';
/**
 * 根据用户权限过滤路由
 * @param route - 权限路由
 * @param roles - 权限
 */
function hasPermission(route: RouteRecordRaw, role: string) {
  return !route.meta?.roles || (route.meta?.roles as string[]).includes(role);
}

/** 递归过滤异步路由表，筛选角色权限路由
 * @param routes - 权限路由组
 * @param roles - 权限
 */
export function filterRoutesByRole(routes: RouteRecordRaw[], role: string) {
  const res: RouteRecordRaw[] = [];
  routes.forEach((route: RouteRecordRaw) => {
    const tmp = { ...route };
    if (hasPermission(tmp, role)) {
      if (tmp.children) {
        tmp.children = filterRoutesByRole(tmp.children, role);
      }
      res.push(tmp);
    }
  });
  return res;
}

/**
 * 根据用户权限过滤路由
 * @param route - 权限路由
 * @param resourceKeySet - 菜单resourceKey 集合
 */
function hasMenuKeyPermission(route: RouteRecordRaw, resourceKeySet: Set<string>) {
  if (!resourceKeySet || resourceKeySet.size <= 0) {
    return false;
  }

  // 二级页面没有配置菜单项，直接允许加载
  if (route.meta?.isMenu == false) {
    return true;
  }

  return resourceKeySet.has(route.name);
}

/** 递归过滤异步路由表，筛选角色权限路由
 * @param routes - 权限路由组
 * @param resourceKeySet - 菜单resourceKey 集合
 */
export function filterRoutesByMenuKey(routes: RouteRecordRaw[], resourceKeySet: Set<string>) {
  const res: RouteRecordRaw[] = [];
  routes.forEach((route: RouteRecordRaw) => {
    const tmp = { ...route };
    if (hasMenuKeyPermission(tmp, resourceKeySet)) {
      if (tmp.children) {
        tmp.children = filterRoutesByMenuKey(tmp.children, resourceKeySet);
      }
      res.push(tmp);
    }
  });
  return res;
}
